import {
  IconAlertTriangle,
  IconArrowRight,
  IconCheck,
  IconChevronLeft,
  IconChevronRight,
  IconCommand,
  IconCreditCard,
  IconFile,
  IconFileText,
  IconHelpCircle,
  IconPhoto,
  IconDeviceLaptop,
  IconLayoutDashboard,
  IconLoader2,
  IconLogin,
  IconShoppingBag,
  IconMoon,
  IconDotsVertical,
  IconPizza,
  IconPlus,
  IconSettings,
  IconSun,
  IconTrash,
  IconBrandTwitter,
  IconUser,
  IconUserCircle,
  IconUserEdit,
  IconUserX,
  IconX,
  IconLayoutKanban,
  IconBrandGithub,
  IconDatabase,
  IconLock,
  IconTruckDelivery,
  IconArrowUp,
  IconArrowDown,
  IconClipboardList,
  IconPackage,
  IconTree,
  IconMenu,
  IconMenu2,
  IconMenu3,
  IconUsers,
  IconShield,
  IconBuilding,
  IconPlug,
  IconRoute,
  IconSitemap,
  IconInbox,
  IconGenderFemale,
  IconServer,
} from "@tabler/icons-react";
import {
  AlertCircleIcon,
  HardDrive,
  Icon,
  Turtle,
  WarehouseIcon,
  PackageCheck,
  PackagePlus,
  PackageMinus,
  Boxes,
  Archive,
} from "lucide-react";

const NittoIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 200 60"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <defs>
      <style>
        {`.nitto-text {
          font-family: Arial, Helvetica, sans-serif;
          font-size: 200px;
          font-weight: bold;
          fill: #00449E ;
        }`}
      </style>
    </defs>
    <text
      x="100"
      y="35"
      className="nitto-text"
      textAnchor="middle"
      dominantBaseline="middle"
    >
      NI
    </text>
  </svg>
);

const PJKIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 180 70"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g transform="translate(5, 5)">
      <path
        d="M 50,60 V 20 C 50,5 65,5 80,5 H 95 C 110,5 125,5 125,20 V 60"
        fill="#008294"
        strokeWidth="0"
      />
      <path
        d="M 125,35 L 165,0 M 100,45 L 165,60"
        fill="none"
        stroke="#005587"
        strokeWidth="22"
        strokeLinecap="round"
      />
      <path
        d="M 10,60 V 0 H 50 C 80,0 80,25 50,25 H 30 V 35 H 50 C 75,35 75,60 50,60 H 10 Z"
        fill="#35A9E0"
        strokeWidth="0"
      />
    </g>
  </svg>
);

const yeonilIcon = ({ className, ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 76 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M37.9995 59.9048L0 0H20.7231L38.0001 32.7429L55.2769 0H76L37.9995 59.9048Z"
      fill="#7D204A"
    />
  </svg>
);

export const Icons = {
  dashboard: IconLayoutDashboard,
  logo: IconCommand,
  login: IconLogin,
  close: IconX,
  product: IconShoppingBag,
  spinner: IconLoader2,
  kanban: IconLayoutKanban,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,
  trash: IconTrash,
  employee: IconUserX,
  post: IconFileText,
  page: IconFile,
  userPen: IconUserEdit,
  user2: IconUserCircle,
  media: IconPhoto,
  settings: IconSettings,
  billing: IconCreditCard,
  ellipsis: IconDotsVertical,
  add: IconPlus,
  warning: IconAlertTriangle,
  user: IconUser,
  arrowRight: IconArrowRight,
  help: IconHelpCircle,
  pizza: IconPizza,
  sun: IconSun,
  moon: IconMoon,
  laptop: IconDeviceLaptop,
  github: IconBrandGithub,
  twitter: IconBrandTwitter,
  check: IconCheck,
  database: IconDatabase,
  sessionLock: IconLock,
  slowQuery: Turtle,
  tablespace: HardDrive,
  wms: WarehouseIcon,
  error: AlertCircleIcon,
  nitto: NittoIcon,
  pjk: PJKIcon,
  yeonil: yeonilIcon,
  // 재고 관련 아이콘들
  inbound: PackagePlus, // 입고
  outbound: PackageMinus, // 출고
  inventory: Boxes, // 재고현황
  stockCheck: PackageCheck, // 재고조사
  delivery: IconTruckDelivery, // 배송
  warehouse: WarehouseIcon, // 창고
  stockIn: IconArrowDown, // 입고 (화살표)
  stockOut: IconArrowUp, // 출고 (화살표)
  stockList: IconClipboardList, // 재고목록
  package: IconPackage, // 패키지
  archive: Archive, // 보관
  tree: IconTree,
  menu: IconMenu,
  menu2: IconMenu2,
  menu3: IconMenu3,
  // FontAwesome 아이콘 매핑
  "fa-users": IconUsers,
  "fa-shield-alt": IconShield,
  "fa-bars": IconMenu,
  "fa-building": IconBuilding,
  "fa-plug": IconPlug,
  "fa-route": IconRoute,
  "fa-sitemap": IconSitemap,
  "fa-inbox": IconInbox,
  "fa-paper-plane": IconInbox,
  "fa-database": IconDatabase,
  "fa-exclamation-triangle": IconAlertTriangle,
  faGear: IconGenderFemale,
  iconServer: IconServer,
};
